export default __webpack_public_path__ + "media/images/banners/bnr_two_week-6ef18f68a1b5130127890f6d59a44938.jpg";